import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Typography } from "@mui/material";
import UserDetail from "./MemberDetailDialog_bak";
import CustomPagination from "../../component/common/CustomPagination";
import { koKRGrid } from "../../component/common/TableKRText";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validatephone(phone: string) {
  const re = /^\(?(\d{3})\)?[- ]?(\d{4})[- ]?(\d{4})$/;
  return re.test(String(phone).toLowerCase());
}

function CustomToolbar(props: any) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <GridToolbarQuickFilter sx={{ marginLeft: "auto" }} />
    </GridToolbarContainer>
  );
}

const columns: GridColDef[] = [
  { field: "id", headerName: "id", width: 70 },
  {
    field: "email",
    headerName: "이메일",
    width: 230,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const isValid = validateEmail(params.props.value);
      return { ...params.props, error: !isValid };
    },
  },
  { field: "name", headerName: "이름", width: 70, editable: true },
  {
    field: "birth",
    headerName: "생년월일",
    width: 100,
    editable: true,
    type: "date",
  },
  {
    field: "gender",
    headerName: "성별",
    width: 100,
    editable: true,
  },
  {
    field: "phone",
    headerName: "전화번호",
    width: 130,
    editable: true,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const isValid = validatephone(params.props.value);
      return { ...params.props, error: !isValid };
    },
  },

  { field: "startDate", headerName: "가입일", width: 270 },

  { field: "roles", headerName: "권한", width: 150, editable: true },
];

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface rowDetailType {
  id: number;
  email: string;
  name: string;
  birth: string;
  gender: string;
  phone: string;
  startDate: string;
  roles: string[];
}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const DataTable = () => {
  const [page, setPage] = useState(1);

  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<rowDetailType>({
    id: 0,
    email: "",
    name: "",
    birth: "",
    gender: "",
    phone: "",
    startDate: "",
    roles: [],
  });
  // api 사용자 정보에서 페이지 정보를 담을 state
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  // 팝업 관리 state
  const [dialogOpen, setDialogOpen] = useState(false);

  const getMemberList = async () => {
    var result = await axios.get("http://localhost:9680/memberList", {
      params: { page: page },
      withCredentials: true,
    });
    console.log("result.data", result.data);
    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        id: idx + 1,
        email: data.email,
        name: data.name,
        birth: data.birth,
        gender: data.gender,
        phone: data.phone,
        startDate: data.startDate,
        roles: data.roles,
      };
    });

    // table에 넣을 rows 데이터 state에 저장
    setRows(datas);
    // pagination에 넣을 api data 페이지 정보를 state에 저장
    setPagination(result.data.pagination);
    // console.log("data", result.data.datas);
  };

  useEffect(() => {
    getMemberList();
  }, [page]);

  const goDetail = (data: any) => {
    console.log("goDetail", data);
    setRowDetail(data);
    setDialogOpen(true);
  };

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    // console.log("CustomFooter pagination", pagination);
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  // console.log(rows);

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
      }}
    >
      <React.Fragment>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>사용자 목록</Typography>

        <ThemeProvider theme={theme}>
          <div style={{ height: 400, width: "100%" }}>
            <DataGrid
              editMode="row"
              rows={rows}
              columns={columns}
              onRowDoubleClick={(e) => goDetail(e.row)}
              checkboxSelection
              pageSize={100}
              components={{ Toolbar: CustomToolbar, Footer: CustomFooter }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              getRowId={(row) => row.email}
              localeText={koKRGrid}
              experimentalFeatures={{ newEditingApi: true }}
            />
          </div>
        </ThemeProvider>
      </React.Fragment>
      {dialogOpen == true ? (
        <UserDetail
          // dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          rowDetail={rowDetail}
          setRowDetail={setRowDetail}
          getMemberList={getMemberList}
        />
      ) : ""}
    </Box>
  );
};
export default DataTable;
